import {
  getSessionStorageMeasureOverviewCompactFilter,
  getSessionStorageMeasureOverviewShowClosedFilter,
  setSessionStorageMeasureOverviewCompactFilter,
  setSessionStorageMeasureOverviewShowClosedFilter,
} from "api/dropsSessionStorage";
import { createContext, useCallback, useState } from "react";

type MeasureOverviewStateContextValues = {
  compact: boolean;
  toggleCompact: () => void;
  showClosed: boolean;
  toggleShowClosed: () => void;
};

const MEASURE_OVERVIEW_STATE_CONTEXT_DEFAULTS: MeasureOverviewStateContextValues =
  {
    compact: false,
    toggleCompact: () => {},
    showClosed: false,
    toggleShowClosed: () => {},
  };

export const useMeasureOverviewStateContextValues = () => {
  const [compact, setCompact] = useState(() =>
    getSessionStorageMeasureOverviewCompactFilter(),
  );
  const [showClosed, setShowClosed] = useState(() =>
    getSessionStorageMeasureOverviewShowClosedFilter(),
  );

  const toggleCompact = useCallback(() => {
    setCompact((prev) => {
      setSessionStorageMeasureOverviewCompactFilter(!prev);
      return !prev;
    });
  }, []);

  const toggleShowClosed = useCallback(() => {
    setShowClosed((prev) => {
      setSessionStorageMeasureOverviewShowClosedFilter(!prev);
      return !prev;
    });
  }, []);

  return { compact, toggleCompact, showClosed, toggleShowClosed };
};

export const MeasureOverviewStateContext = createContext(
  MEASURE_OVERVIEW_STATE_CONTEXT_DEFAULTS,
);
